import { Component } from '@angular/core';
import { CustomerViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/customer-view/customer-view-wrapper.component';

@Component({
  selector: 'app-customer-view-desktop',
  templateUrl: './customer-view-desktop.component.html',
  styleUrls: ['./customer-view-desktop.component.scss'],
})
export class CustomerViewDesktopComponent extends CustomerViewWrapperComponent {
}
